/**
 * assets/filters-upsell.js — click handler only.
 *
 * The card itself is fully SERVER-RENDERED in Liquid (see
 * snippets/cart-drawer-filters-upsell.liquid): counts, delta, tier pricing,
 * and copy are computed server-side and re-rendered automatically on every
 * cart change via the theme's section re-render. This script's only job is
 * adding all recommended items in ONE /cart/add.js call and triggering the
 * theme's drawer refresh — after which the server decides whether the card
 * still renders.
 */
(function () {
  'use strict';

  if (window.__filtersUpsellInit) return;
  window.__filtersUpsellInit = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var busy = false;

  // Delegate from document: survives every drawer DOM swap.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-filters-upsell-add]');
    if (!button) return;
    event.preventDefault();
    addAll(button);
  });

  function addAll(button) {
    if (busy) return;

    var items;
    try {
      items = JSON.parse(button.getAttribute('data-items'));
    } catch (e) {
      console.error('[filters-upsell] bad data-items JSON', e);
      return;
    }
    if (!items || !items.length) return;

    busy = true;
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok || r.status === 422) throw body;
          return body;
        });
      })
      .then(function (addResp) {
        // add.js lacks item_count; fetch true cart state for the icon logic.
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (addResp.sections) {
              document.dispatchEvent(new CustomEvent('cart:ajax-update', {
                detail: {
                  sectionsData: {
                    sections: addResp.sections,
                    id: null,
                    item_count: cart.item_count
                  }
                }
              }));
            } else if (typeof window.refreshCartDrawer === 'function') {
              window.refreshCartDrawer();
            }
            // Server-rendered sections now reflect the new cart; if the delta
            // is satisfied, the re-rendered drawer simply omits the card.
          });
      })
      .catch(function (err) {
        console.error('[filters-upsell] add failed', err);
        var card = document.getElementById('CartDrawerFiltersUpsell');
        var copy = card && card.querySelector('[data-filters-upsell-copy]');
        if (copy) {
          copy.textContent = (err && err.description) ||
            'Couldn\u2019t add filters \u2014 please try again.';
        }
      })
      .finally(function () {
        busy = false;
        // The button may have been replaced by the drawer re-render; only
        // clean up if the original node is still in the document.
        if (document.contains(button)) {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        }
      });
  }
})();
